export default __webpack_public_path__ + "static/media/drink1.0f5e88b1.jpg";